import { render, staticRenderFns } from "./bfmindmap.vue?vue&type=template&id=0608ed32&scoped=true&"
import script from "./bfmindmap.vue?vue&type=script&lang=js&"
export * from "./bfmindmap.vue?vue&type=script&lang=js&"
import style0 from "./bfmindmap.vue?vue&type=style&index=0&id=0608ed32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608ed32",
  null
  
)

export default component.exports